import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { SupportRequest } from '../models/support-request.model';

@Injectable({
  providedIn: 'root'
})
export class ContactSupportService {

  constructor(
    private httpClient: HttpClient,
  ) {}

  sendEmail(request: SupportRequest): Observable<any> {
    const reqOpts = {
      headers: {
        'Access-Control-Allow-Origin' : '*',
        'Content-Type':'application/json'
      },
      withCredentials: true,
    } ;

    let body = {
      "senderName": request.senderName,
      "topic": request.topic,
      "body": request.body,
      "contact": request.contact,
    };

    return  this.httpClient.post(environment.dataServicesURL + 'manage/support/contact', body, reqOpts);
  }
}
